var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"wave",rawName:"v-wave",value:({
    color: '#FFF2CC',
    duration: 0.3,
    initialOpacity: 0.5,
    easing: 'ease-in'
  }),expression:"{\n    color: '#FFF2CC',\n    duration: 0.3,\n    initialOpacity: 0.5,\n    easing: 'ease-in'\n  }"}],staticClass:"py-2 px-6 inline-flex items-center rounded-lg cursor-pointer text-black focus:outline-none",class:_vm.color,on:{"click":_vm.push}},[_c('ion-icon',{attrs:{"size":"small","name":_vm.icon}}),_c('p',{staticClass:"ml-4 font-bold"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }